import React from "react";
import { TablePagination } from "@mui/material";
const Pagination = ({ page, perPage, onPageChange, prevPage, nextPage }) => {
  return (
    <TablePagination
      sx={{
        ".MuiInputBase-root": {
          display: "none",
        },
      }}
      component={"div"}
      page={page}
      rowsPerPage={perPage}
      labelRowsPerPage=""
      labelDisplayedRows={({ from, to }) => `Items ${from} - ${to}`}
      onPageChange={(_, page) => {
        onPageChange({ page: page + 1 });
      }}
      onRowsPerPageChange={(e) => onPageChange({ perPage: e.target.value })}
      count={-1}
      slotProps={{
        actions: {
          nextButton: {
            disabled: nextPage === -1,
          },
          previousButton: {
            disabled: prevPage === -1 || page === 0,
          },
        },
      }}
    />
  );
};

export default Pagination;
